export class User {
    email: string = '';
    avatar: string = '';
    scopes: string[] = [];
}

let ignoreCookieUser: boolean;
let user: User | undefined;

export function setUser(newUser?: User) {
    user = newUser;
}

export function getUser(): User | undefined {
    if (user) {
        return user;
    }
    const cookieUser = getCookieUser();
    setUser(cookieUser);
    return cookieUser;
}

export function getCookieUser(): User | undefined {
    if (ignoreCookieUser) {
        return user;
    }
    ignoreCookieUser = true;

    const prefix = "display=";
    var ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(prefix) === 0) {
            const s = decodeURIComponent(c.substring(prefix.length, c.length));
            const j = JSON.parse(s);
            if (j['email']) {
                return {
                    email: j['email'],
                    avatar: j['avatar'],
                    scopes: j['scopes'],
                }
            }
        }
    }
}
